import { render, staticRenderFns } from "./TableMobileSort.vue?vue&type=template&id=759ad06f&"
import script from "./TableMobileSort.vue?vue&type=script&lang=js&"
export * from "./TableMobileSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports